"use client";

import { ring2 } from "ldrs";

ring2.register();
